import React from 'react';
import styled, {CSSObject} from 'styled-components';

type SpaceLikeProps = {
  direction?: 'vertical' | 'horizontal';
  size?: number;
  width?: string | number;
  customStyles?: CSSObject;
  className?: string;
  onClick?: () => void;
};

const StyledSpaceLike = styled.div<SpaceLikeProps>`
  display: flex;
  flex-direction: ${(props) =>
    props.direction === 'vertical' ? 'column' : 'row'};
  gap: ${(props) => `${props?.size || 8}px`};
  width: ${(props) => props.width};
  ${(props) => props.customStyles};
`;

const SpaceLike: React.FC<SpaceLikeProps> = ({onClick, ...props}) => {
  return (
    <StyledSpaceLike
      onClick={onClick}
      {...props}
      className={props?.className || ''}
    >
      {props.children}
    </StyledSpaceLike>
  );
};

export default SpaceLike;
